import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomerSubscription,
  BackendMutationUpdateCustomerSubscriptionArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation UpdateCustomerSubscription(
    $customerId: ID!
    $plan: String!
    $wordsTier: String
    $billingCycle: String
    $promotionCode: String
  ) {
    updateCustomerSubscription(
      customerId: $customerId
      plan: $plan
      wordsTier: $wordsTier
      billingCycle: $billingCycle
      promotionCode: $promotionCode
    ) {
      status
      latestInvoice {
        paymentIntentStatus
        paymentIntentClientSecret
      }
    }
  }
`;

type Variables = Omit<BackendMutationUpdateCustomerSubscriptionArgs, 'wordsTier'> & {
  tier?: BackendMutationUpdateCustomerSubscriptionArgs['wordsTier'];
};
type Result = Pick<BackendCustomerSubscription, 'status' | 'latestInvoice'>;

export const updateCustomerSubscription = async ({
  customerId,
  plan,
  tier,
  billingCycle,
  promotionCode,
}: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      customerId,
      plan,
      wordsTier: tier,
      billingCycle,
      promotionCode,
    },
  });
  return getSingleProp<Result>(result.data);
};
